export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-black/10 bg-[#ffffff]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-5">
            <a href="#top" className="inline-flex items-center gap-3">
              <img
                src="/brand/mark-dark.png"
                alt="structure media"
                className="h-10 w-auto"
              />
              <span className="subhead text-[10px] text-black/55">
                Creators. Inside &amp; Out.
              </span>
            </a>
            <p className="mt-6 text-[14px] text-[#5a6470] max-w-sm leading-relaxed">
              A real estate media &amp; brand agency. Listings content, brand
              systems, and films built for agents and offices ready to be
              remarkable.
            </p>
          </div>

          <div className="col-span-6 md:col-span-2">
            <span className="overline">Services</span>
            <ul className="mt-4 space-y-2 text-[14px]">
              <li><a href="/#services" className="link-underline">Listings</a></li>
              <li><a href="/#packages" className="link-underline">Packages</a></li>
              <li><a href="/#agency" className="link-underline">Brand &amp; Agency</a></li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-2">
            <span className="overline">Contact</span>
            <ul className="mt-4 space-y-2 text-[14px]">
              <li><a href="mailto:info@structuremedia.me" className="link-underline">info@structuremedia.me</a></li>
              <li><a href="tel:+12078087711" className="link-underline">207-808-7711</a></li>
            </ul>
            <span className="overline mt-6 block">Studio</span>
            <address className="not-italic mt-4 text-[14px] leading-relaxed text-[#5a6470]">
              120 Main Street #243<br />
              Saco, Maine
            </address>
          </div>

          <div className="col-span-12 md:col-span-3">
            <span className="overline">Social</span>
            <ul className="mt-4 space-y-2 text-[14px]">
              <li><a href="https://www.instagram.com/structure_media/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="link-underline">Instagram</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-black/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <span className="overline">© {year} structure media · All rights reserved</span>
          <span className="overline">Designed for clarity. Built for the scroll.</span>
        </div>
      </div>
    </footer>
  );
}
